import { useState, useEffect } from 'react';

export function useIsMobileDevice() {
    const [isMobile, setIsMobile] = useState(
        /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        ) || window.innerWidth < 769
    );

    useEffect(() => {
        function handleResize() {
            setIsMobile(
                /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                ) || window.innerWidth < 769
            );
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
}

export const useScrollDown = ({ overflowElement, showBtn = true }) => {
    const [isScrollDownOptionsBtnVisible, setIsScrollDownOptionsBtnVisible] = useState(false)

    useEffect(() => {
        if (overflowElement && showBtn) {
            if (overflowElement.scrollHeight > overflowElement.clientHeight) {
                setIsScrollDownOptionsBtnVisible(true)
            }
        }
    }, [overflowElement?.scrollHeight, showBtn])

    useEffect(() => {
        if (overflowElement) {
            if (overflowElement?.scrollTop >= 50) {
                setIsScrollDownOptionsBtnVisible(false)
            }
        }
    }, [overflowElement?.scrollTop])

    const handleScrollDownOptions = () => {
        overflowElement.scrollTo({
            top: overflowElement.scrollHeight,
            behavior: "smooth"
        })
        setIsScrollDownOptionsBtnVisible(false)
    }

    return {
        isScrollDownOptionsBtnVisible,
        handleScrollDownOptions,
    }
}